import React, { useState } from "react";
import { usd, ROLES, DIVISIONS } from "./ui";
import "./Dashboard.css";

const STATUS_OPTS = [
  { id: "all", label: "All (Open + Completed/Ongoing)" },
  { id: "co", label: "Completed / Ongoing only" },
  { id: "open", label: "Open only" },
];

export default function ShiftsHours({ data }) {
  const [status, setStatus] = useState("all");
  const stats = data.statsByDivRole;

  // Merge co/open per the selected status.
  const cell = (div, role) => {
    const s = stats?.[div]?.[role] || { co: { shifts: 0, hours: 0, revenue: 0 }, open: { shifts: 0, hours: 0, revenue: 0 } };
    if (status === "co") return s.co;
    if (status === "open") return s.open;
    return { shifts: s.co.shifts + s.open.shifts, hours: s.co.hours + s.open.hours, revenue: s.co.revenue + s.open.revenue };
  };
  const sumRoles = (div) => ROLES.reduce((a, r) => {
    const c = cell(div, r); a.shifts += c.shifts; a.hours += c.hours; a.revenue += c.revenue; return a;
  }, { shifts: 0, hours: 0, revenue: 0 });

  const divTotals = DIVISIONS.map((d) => ({ div: d, ...sumRoles(d) }));
  const grand = divTotals.reduce((a, d) => ({ shifts: a.shifts + d.shifts, hours: a.hours + d.hours, revenue: a.revenue + d.revenue }), { shifts: 0, hours: 0, revenue: 0 });
  const avg = (h, s) => (s ? (h / s).toFixed(1) : "—");
  const num = (n) => Math.round(n).toLocaleString();
  const hrs = (n) => n.toLocaleString(undefined, { maximumFractionDigits: 1 });

  return (
    <div className="dash">
      <section className="panel status-bar">
        <label>STATUS:&nbsp;</label>
        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          {STATUS_OPTS.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
      </section>

      <section className="kpis">
        <div className="kpi"><div className="kpi-label">Total shifts</div><div className="kpi-value">{num(grand.shifts)}</div><div className="kpi-sub">{data.monthLabel}</div></div>
        <div className="kpi"><div className="kpi-label">Total hours</div><div className="kpi-value">{hrs(grand.hours)}</div><div className="kpi-sub">billable</div></div>
        {divTotals.map((d) => (
          <div className="kpi" key={d.div}><div className="kpi-label">{d.div}</div><div className="kpi-value">{num(d.shifts)}</div><div className="kpi-sub">{hrs(d.hours)} hrs · {usd(d.revenue)}</div></div>
        ))}
      </section>

      <section className="panel">
        <div className="panel-head"><h2>Shifts &amp; Billable Hours by Division &amp; Role — {data.monthLabel}</h2></div>
        <table className="grid">
          <thead><tr><th>Division / Role</th><th>Shifts</th><th>Billable Hours</th><th>Avg Hrs/Shift</th><th>Projected Revenue</th></tr></thead>
          <tbody>
            {divTotals.map((d) => (
              <React.Fragment key={d.div}>
                <tr className="subhead-row">
                  <td className="rowhead"><span className={"pill pill-" + d.div.toLowerCase()}>{d.div}</span></td>
                  <td className="strong">{num(d.shifts)}</td>
                  <td className="strong">{hrs(d.hours)}</td>
                  <td className="strong">{avg(d.hours, d.shifts)}</td>
                  <td className="strong">{usd(d.revenue)}</td>
                </tr>
                {ROLES.map((role) => {
                  const c = cell(d.div, role);
                  return (
                    <tr key={d.div + role}>
                      <td className="rowhead indent">{role}</td>
                      <td>{num(c.shifts)}</td>
                      <td>{hrs(c.hours)}</td>
                      <td>{avg(c.hours, c.shifts)}</td>
                      <td>{usd(c.revenue)}</td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ))}
            <tr className="total-row">
              <td className="rowhead">Grand Total</td>
              <td>{num(grand.shifts)}</td>
              <td>{hrs(grand.hours)}</td>
              <td>{avg(grand.hours, grand.shifts)}</td>
              <td>{usd(grand.revenue)}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  );
}
